import script from "./Joey.vue?vue&type=script&setup=true&lang=js"
export * from "./Joey.vue?vue&type=script&setup=true&lang=js"

import "./Joey.vue?vue&type=style&index=0&id=6aa31aa0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa31aa0"]])

export default __exports__